import { DollarSign, TrendingUp, Briefcase, Target } from 'lucide-react';
import { RecentActivity } from '@/components/dashboard/RecentActivity';
import { UpcomingTasks } from '@/components/dashboard/UpcomingTasks';
import { NewsFeed } from '@/components/dashboard/NewsFeed';
import { DashboardMetrics } from '@/components/dashboard/DashboardMetrics';
import { DashboardFilterBar } from '@/components/dashboard/DashboardFilterBar';
import { useDashboardFilters } from '@/hooks/useDashboardFilters';

const stats = [
  {
    type: 'progress' as const,
    title: 'YTD Revenue vs Forecast',
    value: 28400000,
    target: 30000000,
    percentage: 94.7,
    icon: DollarSign,
  },
  {
    type: 'breakdown' as const,
    title: 'Backlog (Firm vs Soft)',
    values: {
      firm: 61250000,
      soft: 12600000,
      total: 73850000
    },
    icon: Briefcase,
  },
  {
    type: 'simple' as const,
    title: 'YOY Revenue Growth',
    value: 12.4,
    unit: '%',
    trend: 'up' as const,
    description: 'Current YTD vs Prior YTD',
    icon: TrendingUp,
  },
  {
    type: 'simple' as const,
    title: 'Bid Hit Rate',
    value: 31.7,
    unit: '%',
    description: 'Awards ÷ Bids (by count or value)',
    icon: Target,
  }
];

export default function Dashboard() {
  const {
    filters,
    updateYear,
    toggleDivision,
    resetFilters,
    hasActiveFilters,
  } = useDashboardFilters();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
          <p className="text-muted-foreground mt-2">
            Welcome back! Here's an overview of your construction business.
          </p>
        </div>
      </div>
      
      <DashboardFilterBar
        filters={filters}
        onUpdateYear={updateYear}
        onToggleDivision={toggleDivision}
        onReset={resetFilters}
        hasActiveFilters={hasActiveFilters}
      />
      
      <DashboardMetrics stats={stats} />
      
      <div className="grid gap-6 md:grid-cols-2">
        <RecentActivity />
        <UpcomingTasks />
      </div>

      {/* News Feed */}
      <NewsFeed />
    </div>
  );
}